import R2ROBOTS_EXT_1 from "./R2ROBOTS_EXT_1";
export default {
  R2ROBOTS_EXT_1,
};
